import queryString from "query-string";
import React from "react";
import {Redirect, Route, Switch, useLocation} from "react-router-dom";
import {
    FACHADMIN,
    LESER_BEHOERDE,
    SYSTEMADMIN,
    ZUST_SBA,
    ZUST_SBB,
    ZUST_SBD,
    ZUST_SBS
} from "../../consts/funktionaleRollen";
import routes from "../../consts/routes.json";
import BetriebsakteView from "../../views/betriebsakte/BetriebsakteView";
import DoubleOptInView from "../../views/DoubleOptInView";
import LoginView from "../../views/LoginView";
import LogoutView from "../../views/LogoutView";
import NotFoundView from "../../views/NotFoundView";
import RegistrationView from "../../views/RegistrationView";
import Startseite from "../../views/Startseite";
import SystemVerwaltungView from "../../views/SystemverwaltungView";
import UnauthorizedView from "../../views/UnauthorizedView";
import EARoute from "../EARoute";
import ProfilView from "../../views/ProfilView";
import {LOGGED_IN_CONDITION, NOT_LOGGED_IN_CONDITION} from "../../utils/SecurityUtils";
import WasserbuchView from "../../views/WasserbuchView";
import AuswertungView from "../../views/AuswertungView";
import PasswordResetView from "../../views/PasswordResetView";

function PageContent() {
    const location = useLocation();
    const {ticket} = queryString.parse(location.search);
    return (
        <main className="page-content">
            <Switch>
                {ticket && <Route path={routes.LOGIN} render={(innerprops) => <LoginView {...innerprops} />}/>}
                <EARoute path={routes.STARTSEITE} exact component={Startseite} condition={LOGGED_IN_CONDITION}/>
                <EARoute path={routes.REGISTRATION} component={RegistrationView} condition={NOT_LOGGED_IN_CONDITION}/>
                <EARoute path={routes.DOUBLE_OPT_IN} component={DoubleOptInView} condition={NOT_LOGGED_IN_CONDITION}/>
                <EARoute path={routes.RESET_PASSWORD} component={PasswordResetView} condition={NOT_LOGGED_IN_CONDITION}/>
                <EARoute
                    path={routes.PROFIL}
                    component={ProfilView}
                    condition={LOGGED_IN_CONDITION}
                />
                <EARoute path={routes.LOGIN} component={LoginView} condition={NOT_LOGGED_IN_CONDITION}/>
                <EARoute path={routes.LOGOUT} component={LogoutView} condition={LOGGED_IN_CONDITION}/>
                <EARoute path={routes.ANWENDER} component={SystemVerwaltungView} condition={[SYSTEMADMIN]}/>
                <EARoute path={routes.AUSWERTUNG} component={AuswertungView} condition={[SYSTEMADMIN, FACHADMIN, LESER_BEHOERDE, ZUST_SBA, ZUST_SBB, ZUST_SBD, ZUST_SBS]}/>
                <EARoute path={routes.ROLLEN} component={SystemVerwaltungView} condition={[SYSTEMADMIN]}/>
                <EARoute path={routes.WERTELISTEN} component={SystemVerwaltungView} condition={[SYSTEMADMIN]}/>
                <EARoute path={routes.ORGANISATIONEN} component={SystemVerwaltungView} condition={[SYSTEMADMIN]}/>
                <EARoute path={routes.BETRIEBSAKTE_WITH_ID} component={BetriebsakteView} condition={LOGGED_IN_CONDITION}/>
                <Redirect from={routes.SYSTEMVERWALTUNG} to={routes.ANWENDER}/>
                <EARoute path={routes.NICHT_GEFUNDEN} component={NotFoundView} condition={LOGGED_IN_CONDITION}/>
                <EARoute path={routes.UNAUTORISIERT} component={UnauthorizedView} condition={LOGGED_IN_CONDITION}/>
                <EARoute path={"/wasserbuch"} component={WasserbuchView} condition={LOGGED_IN_CONDITION}/>
            </Switch>
        </main>
    );
}

export default PageContent;
